export const trustedCompany: { title: string; slug: string }[] = [
  {
    title: 'Gitlab',
    slug: 'gitlab'
  },
  {
    title: 'Tencent',
    slug: 'tencent'
  },
  {
    title: 'Intel',
    slug: 'intel'
  },
  {
    title: 'Google',
    slug: 'google'
  },
  {
    title: 'AWS',
    slug: 'aws'
  },
  {
    title: 'Cyberport',
    slug: 'cyberport'
  },
  {
    title: 'Khazanah',
    slug: 'khazanah'
  },
  {
    title: 'Accenture',
    slug: 'accenture'
  },
  {
    title: 'PWC',
    slug: 'pwc'
  }
]
